export default __webpack_public_path__ + "static/media/demo-11.b1d88f35.png";